/* Visual Lab Redesign: Scroll-Animationen, Parallax, Vorher/Nachher-Slider, Galerie */
(function () {
  var doc = document;
  doc.documentElement.classList.add('vl-js');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var items = (root || doc).querySelectorAll('.vl-reveal:not(.is-in), .vl-zoom:not(.is-in)');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    items.forEach(function (el) { observer.observe(el); });
  }

  function initParallax() {
    if (reduceMotion) return;
    var layers = [].slice.call(doc.querySelectorAll('[data-vl-parallax]'));
    if (!layers.length) return;
    var ticking = false;
    function update() {
      layers.forEach(function (layer) {
        var box = layer.parentElement.getBoundingClientRect();
        if (box.bottom < 0 || box.top > window.innerHeight) return;
        var speed = parseFloat(layer.getAttribute('data-vl-parallax')) || 0.2;
        layer.style.transform = 'translate3d(0,' + (-box.top * speed).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  function initCompare(root) {
    (root || doc).querySelectorAll('.vl-compare').forEach(function (box) {
      var range = box.querySelector('input[type=range]');
      if (!range || box.dataset.vlReady) return;
      box.dataset.vlReady = '1';
      function apply() { box.style.setProperty('--pos', range.value + '%'); }
      range.addEventListener('input', apply);
      apply();
    });
  }

  function loadSlide(img) {
    if (img && img.dataset.src) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }
  }

  function initGallery(root) {
    (root || doc).querySelectorAll('.vl-gallery').forEach(function (gallery) {
      if (gallery.dataset.vlReady) return;
      gallery.dataset.vlReady = '1';
      var stage = gallery.querySelector('.vl-gallery__stage');
      var slides = gallery.querySelectorAll('.vl-gallery__stage img');
      var thumbs = gallery.querySelectorAll('.vl-gallery__thumb');
      var counter = gallery.querySelector('[data-vl-current]');
      var index = 0;
      if (!slides.length) return;

      function go(next) {
        index = (next + slides.length) % slides.length;
        loadSlide(slides[index]);
        loadSlide(slides[(index + 1) % slides.length]);
        slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        var active = thumbs[index];
        if (active) {
          var strip = active.parentElement;
          strip.scrollTo({ left: active.offsetLeft - strip.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
        }
        if (counter) counter.textContent = String(index + 1).padStart(2, '0');
      }

      var prev = gallery.querySelector('.vl-gallery__nav--prev');
      var next = gallery.querySelector('.vl-gallery__nav--next');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { go(i); }); });
      stage.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') go(index - 1);
        if (event.key === 'ArrowRight') go(index + 1);
      });
      var startX = null;
      stage.addEventListener('touchstart', function (event) { startX = event.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (startX === null) return;
        var delta = event.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 40) go(delta < 0 ? index + 1 : index - 1);
        startX = null;
      });
      loadSlide(slides[1]);
    });
  }

  function init(root) {
    initReveal(root);
    initCompare(root);
    initGallery(root);
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () { init(); initParallax(); });
  } else {
    init();
    initParallax();
  }
  doc.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

/* Design-Pakete: Details aller Karten gemeinsam auf- und zuklappen, damit nebeneinander verglichen werden kann */
(function () {
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details.matches || !details.matches('.vl-pkg details')) return;
    var group = details.closest('.vl-packages');
    if (!group) return;
    group.querySelectorAll('.vl-pkg details').forEach(function (other) {
      if (other !== details && other.open !== details.open) other.open = details.open;
    });
  }, true);
})();
